import FragmentLoader from 'hls.js/src/loader/fragment-loader';

export function assignWebWorkerFragmentLoader(hlsPlayer: any): void {
	if (hlsPlayer.isFragLoadWorker) {

		//get default FragLoader and unbind fragLoading event from it.
		const fragLoader = hlsPlayer.player.coreComponents[1]; //taking index 1 is safe for now. revisit later
		fragLoader.destroy();
		hlsPlayer.player.coreComponents[1] = undefined;

		hlsPlayer.player.coreComponents[1] = getFragmentLoader(hlsPlayer.player);
	}
}

function getFragmentLoader(hlsJs): any {
	class VbFragmentLoader extends FragmentLoader {
		public hls: any
		constructor() {
			super(hlsJs);
		}
		onFragLoading(data) {
			this.hls.config.fragType = data?.frag?.type;
			super.onFragLoading(data);
		}
	}
	return new VbFragmentLoader();
}
